module.exports = "<ng-content></ng-content>\n<div class=\"axis x\"></div>\n<div class=\"axis y\"></div>\n"